module.exports = __webpack_public_path__ + "img/spaghetti-soia.3078710c.png";